import { ArrowDownWideNarrow, ArrowUpWideNarrow, Plus, Search } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select";

const STATUS_OPTIONS = [
  ["all", "All statuses"],
  ["registered:true", "Registered"],
  ["registered:false", "Not registered"],
  ["deposited:true", "Deposited"],
  ["deposited:false", "Not deposited"],
  ["purchased:true", "Purchased stock"],
  ["purchased:false", "Not purchased"],
];

const trigger = "h-11 rounded-full border-white/10 bg-white/[0.04] px-4 text-sm text-zinc-200";

export const CrmToolbar = ({ filters, setFilters, admins, onAdd }) => {
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v }));
  const asc = filters.sort === "asc";
  return (
    <div className="flex flex-col gap-3 lg:flex-row lg:items-center" data-testid="crm-toolbar">
      <label className="relative flex-1">
        <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-zinc-400" />
        <input
          data-testid="crm-search-input"
          value={filters.search}
          onChange={(e) => set("search")(e.target.value)}
          placeholder="Search client by name…"
          className="h-11 w-full rounded-full border border-white/10 bg-white/[0.04] pl-11 pr-4 text-sm text-zinc-100 outline-none transition-colors placeholder:text-zinc-500 focus:border-gold/60"
        />
      </label>
      <div className="grid grid-cols-2 gap-3 sm:flex">
        <Select value={filters.admin} onValueChange={set("admin")}>
          <SelectTrigger className={`${trigger} sm:w-44`} data-testid="crm-filter-admin"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All admins</SelectItem>
            {admins.map((a) => <SelectItem key={a.id} value={a.id}>{a.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={filters.status} onValueChange={set("status")}>
          <SelectTrigger className={`${trigger} sm:w-44`} data-testid="crm-filter-status"><SelectValue /></SelectTrigger>
          <SelectContent>
            {STATUS_OPTIONS.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
          </SelectContent>
        </Select>
        <button
          data-testid="crm-sort-toggle"
          onClick={() => set("sort")(asc ? "desc" : "asc")}
          className="flex h-11 items-center justify-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-4 text-sm text-zinc-200 transition-colors hover:border-gold/40"
        >
          {asc ? <ArrowUpWideNarrow className="h-4 w-4" /> : <ArrowDownWideNarrow className="h-4 w-4" />}
          {asc ? "Oldest first" : "Newest first"}
        </button>
        <button
          data-testid="crm-add-client-button"
          onClick={onAdd}
          className="flex h-11 items-center justify-center gap-2 rounded-full bg-gold px-5 text-sm font-semibold text-ink transition-opacity hover:opacity-90"
        >
          <Plus className="h-4 w-4" strokeWidth={2.5} /> Add client
        </button>
      </div>
    </div>
  );
};
